import { createSlice } from '@reduxjs/toolkit';

export const CustomerSlice = createSlice({
    name: 'customer',
    initialState: {
        customers_list: [],
        customer: {},
        customer_permissions: [],
        applicationsListSelect: []
    },
    reducers: {
        setCustomersRedux: ( state, { payload } ) => {
            state.customers_list  =  payload;
        }, 
        setCustomerRedux: ( state, { payload } ) => {
            state.customer  =  payload; 
        },
        setApplicationsListSelectRedux: ( state, { payload } ) => {
            state.applicationsListSelect  =  payload;
        }, 
        updateCustomerListRedux: ( state, { payload } ) => {
            state.customers_list  =  payload;
        },
        emptyCustomerList: ( state, { payload } ) => {
            state.customers_list  =  payload;
        },
        customerPermissionsListRedux: ( state, { payload } ) => {
            state.customer_permissions  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setCustomersRedux, setCustomerRedux, updateCustomerListRedux, 
               customerPermissionsListRedux, setApplicationsListSelectRedux } = CustomerSlice.actions;